namespace TR {
    angular
        .module('TR')
        .directive('trustPilotSeo', (): ng.IDirective => {
            return {
                replace: true,
                restrict: 'E',
                scope: {
                    unitId:'@',
                    reviewTheme:'@',
                    reviewStars:'@',
                    widgetHeight:'@'
                },
                template:`<div class="trustpilot-widget trustpilot-theme-{{ reviewTheme }}" data-locale="en-GB"
                    data-template-id="53aa8912dec7e10d38f59f36" data-businessunit-id="{{unitId}}"
                    data-style-height="{{widgetHeight}}px" data-style-width="100%" data-theme="{{reviewTheme}}"
                    data-stars="{{reviewStars}}" data-schema-type="Organization">
                        <a href="{{ hostName }}" target="_blank">Trustpilot</a>
                    </div>`,
                link: ($scope) => {
                    $scope.hostName = 'https://uk.trustpilot.com/review/www.' + TRPCONFIG.Domain.HostName;
                    setTimeout(() => {
                        let widgetManagement: any = _.get(window, 'Trustpilot.Modules.WidgetManagement');
                        if (widgetManagement && widgetManagement.initializeOnPageLoad) {
                            widgetManagement.initializeOnPageLoad();
                        } else {
                            $(document.body).append(`<script type="text/javascript"
                                src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" async></script>`);
                        }
                    }, 1500);
                }
            };
        });
}
